import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BanksService} from '../../../../services/banks/banks.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-superadmin-users-dwolla',
  templateUrl: './superadmin-users-dwolla.component.html',
  styleUrls: ['./superadmin-users-dwolla.component.scss'],
})
export class SuperadminUsersDwollaComponent implements OnInit {
  public form = this.formBuilder.group({
    amount: ['', Validators.required],
    adjustLedger: [true],
  });
  private userId = '';
  public saving = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private banksService: BanksService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('userId') || '';
  }

  async doAddSubtract(subtract: boolean): Promise<void> {
    const amountRaw = this.form.get('amount')?.value || '';
    if (amountRaw.indexOf('.') < 0) {
      this.snackBar.open('You must provide dollars and cents', 'Close', { duration: 3000 });
      return;
    }
    const amount = parseFloat(amountRaw);
    if (!amount || amount === 0) {
      this.snackBar.open('You must provide a non-zero amount', 'Close', { duration: 3000 });
      return;
    }
    const adjustLedger = this.form.get('adjustLedger')?.value !== false;
    this.saving = true;
    try {
      await this.banksService.adjustDwollaBalance(this.userId, subtract ? -amount : amount, adjustLedger);
      this.snackBar.open(
        `Amount ${subtract ? 'subtracted from' : 'added to'} Dwolla balance${adjustLedger ? ' and ledger' : ''}`,
        'Close',
        { duration: 3000 },
      );
      this.cancel();
    } catch (error) {
      console.error('Dwolla balance adjust failed', error);
      this.snackBar.open('Dwolla balance adjust failed', 'Close', { duration: 3000 });
    } finally {
      this.saving = false;
    }
  }

  add(): void {
    this.doAddSubtract(false).then();
  }

  subtract(): void {
    this.doAddSubtract(true).then();
  }

  cancel(): void {
    this.router.navigate(['/superadmin/users/detail']).then();
  }
}
